import { Form, Select, Tag } from 'antd';
import React, { useMemo } from 'react';
import { TRANSFORMATIONS_WITH_SOURCE_FIELD } from '../../../../../utils/const/mapping';

import { useGroupedFieldOptions } from '../../../../../hooks/useGroupedFieldOptions';

/**
 * Composant de sélection du champ source pour les transformations
 * qui nécessitent de spécifier un champ source.
 */
const SourceFieldSelect = ({
  value,
  onChange,
  transformationType,
  fieldNamePrefix = [],
}) => {
  const { groupedFieldOptions } = useGroupedFieldOptions();

  // Vérifie si ce type de transformation nécessite un champ source
  const showSourceField = useMemo(() => {
    return TRANSFORMATIONS_WITH_SOURCE_FIELD.includes(transformationType);
  }, [transformationType]);

  if (!showSourceField) {
    return null;
  }

  return (
    <Form.Item
      label="Champ source"
      name={fieldNamePrefix}
      rules={[
        { required: true, message: 'Veuillez sélectionner un champ source' },
      ]}
      initialValue={value}
    >
      <Select
        style={{ width: '100%' }}
        placeholder="Sélectionnez un champ source"
        showSearch
        optionFilterProp="label"
        options={groupedFieldOptions}
        onChange={onChange}
        optionRender={(option) => (
          <span
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {option.label}
            {option.data.metric && <Tag>{option.data.metric}</Tag>}
          </span>
        )}
        allowClear
      />
    </Form.Item>
  );
};

export default SourceFieldSelect;
